import { render, staticRenderFns } from "./TokenHistoryItem.vue?vue&type=template&id=20a6085c&scoped=true"
import script from "./TokenHistoryItem.vue?vue&type=script&lang=js"
export * from "./TokenHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./TokenHistoryItem.vue?vue&type=style&index=0&id=20a6085c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6085c",
  null
  
)

export default component.exports